/**
 * Shared helpers for CSV attachment endpoints (blob response + Content-Disposition file name).
 */

export function defaultCsvName(prefix: string): string {
  const today = new Date().toISOString().slice(0, 10)
  return `${prefix}-${today}.csv`
}

export function extractFilename(disposition: string | undefined): string | undefined {
  if (!disposition) return undefined
  const star = /filename\*=UTF-8''([^;]+)/.exec(disposition)
  if (star) return decodeURIComponent(star[1])
  const plain = /filename="([^"]+)"/.exec(disposition)
  return plain?.[1]
}

export function filenameFromHeaders(headers: unknown, fallbackPrefix: string): string {
  const disposition = (headers as Record<string, string | undefined>)['content-disposition']
  return extractFilename(disposition) ?? defaultCsvName(fallbackPrefix)
}

/** Triggers a browser download for an already-fetched blob. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
